import request from './fetcher/request'
import client from '@/client/modules/common'

// 获取支付信息第三版
function getPaySetting (data) {
  return request.post('/api/sdk/pay/settings', data)
}
// 获取二维码信息
async function getPayQrcode (data) {
  try {
    const { lastver } = await client.API.client_get_device_info()
    data.client_ext = {
      lastver: lastver ? String(lastver) : '0'
    }
  } catch (error) {
    data.client_ext = {
      lastver: '0'
    }
  }
  return request.post('/api/sdk/pay', data)
}
// 支付结果轮询接口
function getPayResult (data) {
  return request.post('/api/sdk/pay/wx_result', data)
}

// 获取jsSDK配置
function getJsSdkConfig (data) {
  return request.post('/api/sdk/pay/config', data)
}
export { getPayResult, getPayQrcode, getPaySetting, getJsSdkConfig }
